<template>
  <div>
    <van-field
      v-model="val"
      :label="label"
      :placeholder="placeholder || label"
      :required="required"
      :rules="rules"
      readonly
      is-link
      @click="show = true"
    />
    <van-popup v-model="show" position="bottom" round >
      <van-datetime-picker
        v-model="currDate"
        :title="'选择 ' + label"
        :min-date="minDate"
        :max-date="maxDate"
        :type="type"
        @confirm="change"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    type: {
      type: String,
      default: 'date'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    minDate: {
      type: Date,
      default: function() {
        return new Date(1990, 1, 1);
      }
    },
    maxDate: {
      type: Date,
      default: function() {
        return new Date(2030, 1, 1);
      }
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value,
      currDate: this.value ? new Date(this.value) : new Date(),
      msg: this.placeholder ? null : '请输入' + this.label,
      rules: [{ required: 'required', message: this.msg }]
    };
  },
  watch: {
    value: function(value) {
      this.val = value;
      this.currDate = new Date(value);
    }
  },
  methods: {
    change(value) {
      this.val = this.Utils.df(value, '{y}-{m}-{d}');
      this.$emit('change', this.val);
      this.show = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/base/BaseDate.vue